<!--
    描述：用户组人员列表
    时间：2020-04-26
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-tabs overflow-hidden">
					<span><b>项目成员</b></span>
				</div>
				<div class="btnGroups ml10">
					<el-button v-if="clickType =='virtualDeptClick' && roleBtns.includes('user_add')"
							   type="primary"
							   size="small"
							   @click="doClick('add')">保存
					</el-button>
				</div>
			</div>
			<div class="w-page-container">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content"
						 ref="usersContent">
						<el-table ref="groupUsersTable"
								  v-loading="groupUsersData.loading"
								  :data="groupUsersData.tableData"
								  :border="true"
								  :height="groupUsersData.tableH"
								  highlight-current-row>
							<el-table-column align="center" v-if="clickType =='virtualDeptClick'"
											 type="selection"
											 width="45"></el-table-column>
							<el-table-column prop="sname"
											 header-align="center"
											 label="人员姓名"
											 show-overflow-tooltip
											 width="110"></el-table-column>
							<el-table-column prop="username"
											 header-align="center"
											 label="用户名"
											 show-overflow-tooltip
											 width="135"></el-table-column>
                            <el-table-column prop="positionName"
                                             align="center"
                                             label="岗位"
                                             show-overflow-tooltip
                                             width="120"></el-table-column>
                            <el-table-column prop="roleNames"
                                             header-align="center"
                                             label="角色"
                                             show-overflow-tooltip
                                             mint-width="120">
                            </el-table-column>
						    <!--
						    <el-table-column prop="dataScope"
                                             label="权限范围"
                                             show-overflow-tooltip
                                             min-width="150">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row[scope.column.property]"
                                               clearable
                                               placeholder=""
                                               size="small"
                                               @change="authScopeSelectChange($event, scope.row)">
                                        <el-option v-for="item in authScopeSelectList"
                                                   :key="item.id"
                                                   :label="item.sname"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            -->
							<el-table-column label="操作"
											 align="center"
											 width="75"
											 show-overflow-tooltip>
								<template slot-scope="scope">
                                    <el-button size="mini"
                                               icon="el-icon-setting"
                                               title="设置角色"
                                               type="text"
                                               v-if="roleBtns.includes('group_user_role_set')"
                                               @click="doClick('group_user_role_set',scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
                                               v-if="roleBtns.includes('user_delete')"
											   @click="doClick('delete',scope.row)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer text-center">
						<el-pagination @size-change="handleSizeChange"
									   @current-change="handleCurrentChange"
									   :current-page="groupUsersData.currentPage"
									   :page-sizes="groupUsersData.pageList"
									   :page-size="groupUsersData.pageSize"
									   layout="total, sizes, prev, pager, next, jumper"
									   :total="groupUsersData.total"></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title"
                   :visible.sync="dialogObj.visible"
                   :width="dialogObj.width"
				   center
                   :close-on-click-modal="false"
                   @closed="handleClose">
            <!-- 弹窗组件 -->
            <div style="height:400px">
                <el-tree ref="groupRoleTree"
                         :height="roleTreeObj.tableH"
                         :data="roleTreeObj.data"
                         :props="defaultProps"
                         :expand-on-click-node="false"
                         :highlight-current="true"
                         default-expand-all
                         show-checkbox
                         :check-strictly="true"
                         node-key="id"
                         :default-checked-keys="treeDefaultCheckedKey"
                ></el-tree>
            </div>
            <!-- footer 组件 -->
            <div slot="footer"
                 class="dialog-footer text-center" >
                <el-button size="small"
                           @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary"
                           size="small"
                           :loading="btnLoading"
                           @click="doSaveGroupRole">确 定</el-button>
            </div>
        </el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getGroupUsers } from 'api/system/user.js'
import { saveUserStations, deleteGroupUser } from 'api/system/group.js'
import { getDictByParentValue } from 'api/system/sys.js'
import { selectRoleTree } from 'api/system/role.js'
import { getAllList } from 'api/system/sysGroupInnerRole.js'
import { saveUserGroupRole } from 'api/system/sysUserGroupRole.js'

export default {
	data() {
		return {
		    //数据权限下拉列表信息
		    authScopeSelectList: [],
		    //选中人员列表
		    checkedList : [],

			groupUsersData: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			clickType: 'groupsClick',
			searchParam: {},
			//用户组下拉列表信息
			groupRoleTreeData: [],

			btnLoading: false,
            //弹框对象
            dialogObj: {
                title: '',
                visible: false,
                width: '450px',
            },
            //角色树
            roleTreeObj: {
                loading: false,
                tableH: 400,
                data: [],
            },
            defaultProps: {
                children: 'children',
                label: 'roleName'
            },
            //用户组角色默认选中信息
            treeDefaultCheckedKey : [],

            //行点击用户
            clickUserObj : [],
		}
	},
	methods: {
		getGroupUsers(row, clickType) {
			this.clickType = clickType
			this.searchParam = row
			let param = {}
			if (clickType === 'groupsClick') {
				param.groupId = row.id
			} else {
				param.groupId = row.groupId
				param.virtualGroupId = row.id
			}
			param.groupType = clickType
			param.current = this.groupUsersData.currentPage
			param.size = this.groupUsersData.pageSize
			getGroupUsers(param).then(res => {
			    this.groupUsersData.tableData = []
			    if(res.operationCode == 1) {
			        if(res.data != null) {
			            this.groupUsersData.tableData = res.data.records
                        this.groupUsersData.total = parseInt(res.data.total)
                    }
                    setTimeout(() => {
                        this.groupUsersData.tableData
                            .filter(f => f.isChecked === true)
                            .forEach(v =>
                                this.$refs.groupUsersTable.toggleRowSelection(
                                    v,
                                    true
                                )
                            )
                    }, 10)
			    }

			})
		},

		// 获取数据权限 范围码表
        getAuthScopeDict() {
            let that = this
            let param = { value: 1004 }
            getDictByParentValue(param).then(res => {
                if (res.operationCode == 1) {
                    that.authScopeSelectList = res.data
                }
            })
        },
        // 权限范围切换事件
        authScopeSelectChange(value, row) {
            let _item = this.groupUsersData.tableData.find(x => x.id === row.id)

            if (_item) {
                _item.dataScope = value
            }
        },

		//操作按钮事件
		doClick(type, row) {
			if (type === 'delete') {
				this.$confirm('确认从当前用户组移除该人员?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteGroupUser(row)
				})
			} else if(type == 'group_user_role_set'){
			    this.treeDefaultCheckedKey = []
                this.dialogObj.title = '设置角色'
                this.dialogObj.visible = true
                this.clickUserObj = row
                this.treeDefaultCheckedKey = row.roleIds
                this.getAllList()
			}else {
				let array = this.$refs.groupUsersTable.selection
				if (!array.length > 0) {
					this.$message.warning('请勾选人员！')
				} else {
					let stationArray = []
					array.forEach(v =>
						stationArray.push({
							stationId: this.searchParam.id,
							userId: v.id,
							dataScope: v.dataScope
						})
					)
					this.doSave(stationArray)
				}
			}
		},

		//保存关联关系
		doSave(stationArray) {
			saveUserStations(stationArray).then(res => {
				res.code === 0
					? this.$message.success('保存成功！')
					: this.$message.error(res.msg)
			})
		},

		//移除用户组人员
		deleteGroupUser(row) {
			let param = {}
			param.groupId =
				this.clickType === 'groupsClick'
					? this.searchParam.id
					: this.searchParam.groupId
			param.stationId =
				this.clickType === 'virtualDeptClick' ? this.searchParam.id : ''
			param.userId = row.id
			deleteGroupUser(param).then(res => {
				res.code === 0
					? this.$message.success('移除人员成功！')
					: this.$message.error(res.msg)
				this.getGroupUsers(this.searchParam, this.clickType)
			})
		},

        //获取用户组角色信息
        getAllList(){
            let that = this
            this.roleTreeObj.data = []
            let param = {}
            if (this.clickType === 'groupsClick') {
                param.groupId = this.searchParam.id
            } else {
                param.groupId = this.searchParam.groupId
            }
            getAllList(param).then(res=>{
                if(res.operationCode == 1) {
                    this.roleTreeObj.data = that.$utils.toArrayTree(res.data)
                }
            })
        },

        // 确定按钮事件
        doSaveGroupRole() {
            let that = this
            let param = {}
            if (this.clickType === 'groupsClick') param.groupId = this.searchParam.id
            else param.groupId = this.searchParam.groupId
            param.userId = this.clickUserObj.id
            param.roleIdList = this.$refs.groupRoleTree.getCheckedKeys().concat()
            saveUserGroupRole(param).then(res=>{
                if(res.operationCode == 1) {
                    this.dialogObj.visible = false
                    this.$message({'message' : '保存成功', type: 'success'})
                    this.getGroupUsers(this.searchParam, this.clickType)
                }
            })
        },

        // 关闭弹窗事件
        handleClose() {},

		// 切换显示条数
		handleSizeChange(val) {
			this.groupUsersData.pageSize = val
			this.getGroupUsers(this.searchParam, this.clickType)
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.groupUsersData.currentPage = cur
			this.getGroupUsers(this.searchParam, this.clickType)
		}
	},

	created() {
		this.$nextTick(() => {
			setTimeout(() => {
			    //数据权限字典信息
                //this.getAuthScopeDict()


				this.groupUsersData.tableData
					.filter(f => f.isChecked === true)
					.forEach(v =>
						this.$refs.groupUsersTable.toggleRowSelection(v, true)
					)
			}, 100)
		})
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.groupUsersData.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},

	// 进入缓存页面
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.groupUsersData.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		clientSize(val) {
			this.groupUsersData.tableH = this.$refs.usersContent.offsetHeight
		}
	}
}
</script>
<style lang="less"></style>
